import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { getIcon } from "@/lib/icons";
import { Reveal } from "@/components/common/Reveal";

export const ServiceCard = ({ service, index = 0 }) => {
  const Icon = getIcon(service.icon);
  return (
    <Reveal delay={(index % 3) * 0.06}>
      <Link
        to={`/services/${service.slug}`}
        data-testid={`service-card-${service.slug}`}
        className="group block h-full rounded-[var(--cdt-radius-md)] bg-white border border-[color:var(--cdt-border)] shadow-[var(--cdt-shadow-sm)] hover:shadow-[var(--cdt-shadow-md)] transition-shadow p-6"
      >
        <div className="h-11 w-11 rounded-full bg-[rgba(15,92,90,0.08)] flex items-center justify-center">
          <Icon className="h-5 w-5 text-[var(--cdt-primary)]" />
        </div>
        <h3 className="font-display text-xl mt-4 text-[var(--cdt-text)]">{service.name}</h3>
        <p className="mt-2 text-sm leading-7 text-[var(--cdt-muted)] line-clamp-3">{service.summary}</p>
        <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-[var(--cdt-primary)]">
          Learn more <ArrowRight className="h-4 w-4 group-hover:translate-x-0.5 transition-transform" />
        </span>
      </Link>
    </Reveal>
  );
};
